import { isNil, isNotNil } from "ramda";
import type { AnyObject, Flags, Maybe, ObjectSchema, ObjectShape, StringSchema } from "yup";
import * as Yup from "yup";

declare module "yup" {
  interface ObjectSchema<
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TIn extends Maybe<AnyObject>,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TContext = AnyObject,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    TDefault = any,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TFlags extends Flags = "",
  > {
    range(limits?: { min: number; max: number; message: string }): this;
  }
  interface StringSchema {
    manualResult(range: { min: number; max: number }, message: string): this;
  }
}

Yup.addMethod<ObjectSchema<ObjectShape>>(
  Yup.object,
  "range",
  function (limits?: { min: number; max: number; message: string }) {
    const test: ObjectSchema<ObjectShape> = this.test(
      "is-range-allvalues",
      "Min and max values should be set for range",
      (value) => isNil(value) || (!isNil(value.min) && !isNil(value.max))
    ).test("is-range-minmax", "Min value should be lower than max", (value) => isNil(value) || value.min < value.max);
    if (isNotNil(limits)) {
      return test.test(
        "is-range-in-limits",
        limits.message,
        (value) =>
          isNil(value) ||
          isNil(value.min) ||
          isNil(value.max) ||
          Number.isNaN(Number(value.min)) ||
          Number.isNaN(Number(value.max)) ||
          (Number(value.min) >= limits.min &&
            Number(value.min) <= limits.max &&
            Number(value.max) >= limits.min &&
            Number(value.max) <= limits.max)
      );
    }
    return test;
  }
);

export const resultToNumber = (result: string): number => {
  return Number(result.replace(/^[<>]/gm, ""));
};

Yup.addMethod<StringSchema>(Yup.string, "manualResult", function ({ min, max }, message) {
  return this.test("is-result-in-range", message, (value) => {
    if (isNil(value)) {
      return true;
    }
    const result = resultToNumber(value);
    return !isNaN(result) && result >= min && result <= max;
  });
});

export { Yup };
